import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

const API_LIST = '/manufacturers';
const API_DETAIL = (id: number) => `/manufacturers/${id}`;

export interface Manufacturer {
  id: number;
  name?: string;
}

export const useManufacturers = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<Manufacturer[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    manufacturers: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const useManufacturer = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<Manufacturer>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    manufacturer: data,
    isLoading,
    isError: error,
    mutate,
  };
};
